export default __webpack_public_path__ + "static/media/Captain's Boots of the Shining Sun.99a8026b.jpg";